module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/2000-12-25/2000-12-25_times-364b3228ba0c23cb16f4f9af1e14d9a4.gif";